import { useContext } from '@nuxtjs/composition-api';
import useCustomUserId from '@shared/composables/useCustomUserId';

import useAlgoliaEvents from './internal/useAlgoliaEvents';

const useSearchInsights = () => {
  const { $config } = useContext();
  const { customUserId } = useCustomUserId();

  return useAlgoliaEvents({
    apiKey: $config.algoliaApiKey,
    appId: $config.algoliaAppId,
    authenticatedUserToken: customUserId,
  });
};

export default useSearchInsights;
